import React from "react";
import Dialog from "Components/Core/Dialog";
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import './DialogNewImage.css';


export default function DialogNewImage(props) {

	const x = props.x;
	const image = React.useRef(null);
	const imageId = props.moduleId + '-image-from-clipboard';
	const [renderDialog, setRenderDialog] = React.useState(Date.now());
	

	var wafId = props.dialogId;
	x.waf.init(wafId);

	React.useEffect(() => {
		x.wad[props.id].setImage = setImage;
		x.wad[props.id].activate = activate;
		// x.waf[wafId].ok = upload;
		x.waf.focus(wafId, 'note');
	});
	// console.log('focus');

	function setImage(newImage) {
		image.current = newImage;
	}

	function activate(initialNote = '') {
		x.waf.setSource(props.moduleId + '-new-image', props.moduleId + '-image-from-clipboard', URL.createObjectURL(image.current));
		// Bereits im Composer getippter Text (siehe Webapp.js-Paste-Handler) landet
		// hier statt verworfen zu werden - Mitglieder tippten oft schon einen
		// Kommentar, bevor sie zusaetzlich ein Bild einfuegten.
		x.waf.set(props.moduleId + '-new-image', 'note', initialNote);
		x.wad[props.moduleId + '-new-image'].show();
		setRenderDialog(Date.now());
	}

	function upload(event) {
		event.preventDefault();
		const formData = new FormData();
		formData.append('image', image.current, 'image.png');
		x.was.axPost('Backend/webapp.php?module=Posting&task=ImageFromClipboard', formData, (result) => {
			if (result.data.returncode === 1) {
				x.wad[props.moduleId + '-new-image'].hide();
				const newThreadID = props.moduleId + '-new-thread';
				const answerID = props.moduleId + '-answer';
				// IDs überprüfen!!! 
				if (!x.wad[newThreadID].isVisible && !x.wad[answerID].isVisible) {
					x.wad[newThreadID].show(() => { x.waf.focus(newThreadID, 'posting') });
				}
				if (x.wad[answerID].isVisible) {
					addLink(answerID, result.data.content.fileName);
				}
				else {
					addLink(newThreadID, result.data.content.fileName);
				}
			}
			else {
				console.log('Image Upload Error!');
			}
		})
	}

	function addLink(wafIdTarget, fileName) {
		const addNote = (x.waf.get(wafId, 'note') === '') ? '' : '' + x.waf.get(wafId, 'note') + '\r\n';
		const addContent = addNote + '\r\n[img]Backend/image.php?file=' + fileName + '[/img]\r\n';
		const curPos = x.waf[wafIdTarget].elements['posting'].reference.current.selectionStart;
		const curVal = x.waf.get(wafIdTarget, 'posting');
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		// x.waf.set(wafId,'posting',leftValue + '[addContent=' + addContent + ']' + addContent + '[/addContent]' + rightValue);
		x.waf.set(wafIdTarget, 'posting', leftValue + addContent + rightValue);
		x.waf.focus(wafIdTarget, 'posting');
		x.waf.setCursorPos(wafIdTarget, 'posting', 0, 0);
	}


	return (
		<Dialog id={props.id} x={x} title="Bild aus Zwischenablage importieren" classes="dialog-new-image ">
			<Form x={x}
				wafId={wafId}
				enableSendButton={true}
				sendButtonTitle="Datei hochladen"
				onSubmit={upload}
				focusElement="name"
				classes="dialog-new-image-form"
				checkChanged={() => { return true; }}
			>
				<FormElement
					type="text"
					id="note"
					x={x}
					dialogId={props.id}
					wafId={wafId}
					mandatory={false}
					title={(props.answerTo === 0) ? props.titleText : "Ihre Anmerkung:"}
					fieldValue=""
				/>

				<div className="div-new-image">
					{(renderDialog > 0) ? <FormElement type="image" x={x} wafId={wafId} id={imageId} /> : null}
				</div>
				<label id="login-error" >Bitte Bildrechte und Lizenzen beachten!</label>
			</Form>
		</Dialog>

	);


}
